export default {
  en: {
    premium: 'Get Premium',
    login: 'Sign in',
    guestName: 'Guest',
    logout: 'Log out',
  },
  ru: {
    premium: 'Подключить Премиум',
    login: 'Войти',
    guestName: 'Гость',
    logout: 'Выйти',
  },
};
